export const validateId = (id: ID): boolean => {
  return typeof id === "string" && /^\d+$/.test(id);
};
